var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row bg-grey-50 rounded-md p-16 items-center"},[_c('InfoCircle',{staticClass:"w-24 flex-shrink-0"}),_c('p',{class:['font-sans-light ml-8', _vm.textClass]},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }